import React from 'react';

import { withStyles, WithTheme } from '@material-ui/core';
import Select, { SelectProps } from 'core/Select';
import { get, omit } from 'lodash';

export type TextFieldSelectValues = { id: string; redirectType: string; label: string }[];

export interface TextFieldSelectProps extends Omit<SelectProps, 'classes' | 'loadOptions' | 'onChange'>, WithTheme {
  onChange: (values: TextFieldSelectValues) => void;
  shouldAutoFocus: boolean;
}

const TextFieldSelect: React.FC<TextFieldSelectProps> = ({ theme, shouldAutoFocus, options, ...rest }) => (
  <Select
    margin="none"
    menuPlacement="top"
    isClearable={false}
    hideNoResults
    hideSelectedOptions
    noAdornment
    shouldAutoFocus={shouldAutoFocus}
    breakWhiteSpace
    TextFieldProps={{
      InputProps: {
        disableUnderline: true,
        // WORKAROUND: We can't pass masked inputs to `react-select` components
        ...omit(get(rest, 'InputProps'), ['inputComponent']),
      },
    }}
    options={options}
    {...rest}
  />
);

export default withStyles({}, { name: 'TextFieldSelect', withTheme: true })(TextFieldSelect);
